var _assertThisInitialized = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _toConsumableArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e7) { throw _e7; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e8) { didErr = true; err = _e8; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

!function (t) {
  "function" == typeof define && define.amd ? define(t) : t();
}(function () {
  "use strict";

  function t() {}

  var e = function e(t) {
    return t;
  };

  function n(t, e) {
    for (var _n in e) {
      t[_n] = e[_n];
    }

    return t;
  }

  function o(t) {
    return t();
  }

  function i() {
    return Object.create(null);
  }

  function r(t) {
    t.forEach(o);
  }

  function s(t) {
    return "function" == typeof t;
  }

  function c(t, e) {
    return t != t ? e == e : t !== e || t && "object" == typeof t || "function" == typeof t;
  }

  function l(t, e) {
    return t != t ? e == e : t !== e;
  }

  function a(t) {
    return 0 === Object.keys(t).length;
  }

  function u(e, n, o) {
    e.$$.on_destroy.push(function (e) {
      if (null == e) return t;

      for (var _len = arguments.length, n = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        n[_key - 1] = arguments[_key];
      }

      var o = e.subscribe.apply(e, n);
      return o.unsubscribe ? function () {
        return o.unsubscribe();
      } : o;
    }(n, o));
  }

  var d = "undefined" != typeof window;
  var f = d ? function () {
    return window.performance.now();
  } : function () {
    return Date.now();
  },
      h = d ? function (t) {
    return requestAnimationFrame(t);
  } : t;
  var g = new Set();

  function p(t) {
    g.forEach(function (e) {
      e.c(t) || (g.delete(e), e.f());
    }), 0 !== g.size && h(p);
  }

  function m(t) {
    var e;
    return 0 === g.size && h(p), {
      promise: new Promise(function (n) {
        g.add(e = {
          c: t,
          f: n
        });
      }),
      abort: function abort() {
        g.delete(e);
      }
    };
  }

  function $(t, e) {
    t.appendChild(e);
  }

  function y(t) {
    if (!t) return document;
    var e = t.getRootNode ? t.getRootNode() : t.ownerDocument;
    return e && e.host ? e : t.ownerDocument;
  }

  function b(t, e) {
    $(t.head || t, e);
  }

  function w(t, e, n) {
    t.insertBefore(e, n || null);
  }

  function v(t) {
    t.parentNode.removeChild(t);
  }

  function x(t) {
    return document.createElement(t);
  }

  function k(t) {
    return document.createElementNS("http://www.w3.org/2000/svg", t);
  }

  function _(t) {
    return document.createTextNode(t);
  }

  function E() {
    return _(" ");
  }

  function T() {
    return _("");
  }

  function C(t, e, n) {
    null == n ? t.removeAttribute(e) : t.getAttribute(e) !== n && t.setAttribute(e, n);
  }

  function P(t, e, n, o) {
    t.style.setProperty(e, n, o ? "important" : "");
  }

  function z(t, e, n) {
    t.classList[n ? "add" : "remove"](e);
  }

  function S(t) {
    var e = {};

    var _iterator = _createForOfIteratorHelper(t),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _n2 = _step.value;
        e[_n2.name] = _n2.value;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return e;
  }

  var D = new Set();
  var I,
      R = 0;

  function F(t, e, n, o, i, r, s) {
    var c = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
    var l = 16.666 / o;
    var a = "{\n";

    for (var _t2 = 0; _t2 <= 1; _t2 += l) {
      var _o = e + (n - e) * r(_t2);

      a += 100 * _t2 + "%{".concat(s(_o, 1 - _o), "}\n");
    }

    var u = a + "100% {".concat(s(n, 1 - n), "}\n}"),
        d = "__svelte_".concat(function (t) {
      var e = 5381,
          n = t.length;

      for (; n--;) {
        e = (e << 5) - e ^ t.charCodeAt(n);
      }

      return e >>> 0;
    }(u), "_").concat(c),
        f = y(t);
    D.add(f);

    var h = f.__svelte_stylesheet || (f.__svelte_stylesheet = function (t) {
      var e = x("style");
      return b(y(t), e), e;
    }(t).sheet),
        g = f.__svelte_rules || (f.__svelte_rules = {});

    g[d] || (g[d] = !0, h.insertRule("@keyframes ".concat(d, " ").concat(u), h.cssRules.length));
    var p = t.style.animation || "";
    return t.style.animation = "".concat(p ? "".concat(p, ", ") : "").concat(d, " ").concat(o, "ms linear ").concat(i, "ms 1 both"), R += 1, d;
  }

  function N(t, e) {
    var n = (t.style.animation || "").split(", "),
        o = n.filter(e ? function (t) {
      return t.indexOf(e) < 0;
    } : function (t) {
      return -1 === t.indexOf("__svelte");
    }),
        i = n.length - o.length;
    i && (t.style.animation = o.join(", "), R -= i, R || h(function () {
      R || (D.forEach(function (t) {
        var e = t.__svelte_stylesheet;
        var n = e.cssRules.length;

        for (; n--;) {
          e.deleteRule(n);
        }

        t.__svelte_rules = {};
      }), D.clear());
    }));
  }

  function A(t) {
    I = t;
  }

  function B() {
    if (!I) throw new Error("Function called outside component initialization");
    return I;
  }

  var M = [],
      j = [],
      O = [],
      L = [],
      U = Promise.resolve();
  var V = !1;

  function H(t) {
    O.push(t);
  }

  var W = !1;
  var q = new Set();

  function G() {
    if (!W) {
      W = !0;

      do {
        for (var _t3 = 0; _t3 < M.length; _t3 += 1) {
          var _e = M[_t3];
          A(_e), J(_e.$$);
        }

        for (A(null), M.length = 0; j.length;) {
          j.pop()();
        }

        for (var _t4 = 0; _t4 < O.length; _t4 += 1) {
          var _e2 = O[_t4];
          q.has(_e2) || (q.add(_e2), _e2());
        }

        O.length = 0;
      } while (M.length);

      for (; L.length;) {
        L.pop()();
      }

      V = !1, W = !1, q.clear();
    }
  }

  function J(t) {
    if (null !== t.fragment) {
      t.update(), r(t.before_update);
      var _e3 = t.dirty;
      t.dirty = [-1], t.fragment && t.fragment.p(t.ctx, _e3), t.after_update.forEach(H);
    }
  }

  var K;

  function Q(t, e, n) {
    t.dispatchEvent(function (t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var o = document.createEvent("CustomEvent");
      return o.initCustomEvent(t, n, !1, e), o;
    }("".concat(e ? "intro" : "outro").concat(n)));
  }

  var X = new Set();

  function Y(t, e) {
    t && t.i && (X.delete(t), t.i(e));
  }

  var Z = {
    duration: 0
  };

  function tt(n, o, i) {
    var r,
        c,
        l = o(n, i),
        a = !1,
        u = 0;

    function d() {
      r && N(n, r);
    }

    function h() {
      var _ref = l || Z,
          _ref$delay = _ref.delay,
          o = _ref$delay === void 0 ? 0 : _ref$delay,
          _ref$duration = _ref.duration,
          i = _ref$duration === void 0 ? 300 : _ref$duration,
          _ref$easing = _ref.easing,
          s = _ref$easing === void 0 ? e : _ref$easing,
          _ref$tick = _ref.tick,
          h = _ref$tick === void 0 ? t : _ref$tick,
          g = _ref.css;

      g && (r = F(n, 0, 1, i, o, s, g, u++)), h(0, 1);
      var p = f() + o,
          $ = p + i;
      c && c.abort(), a = !0, H(function () {
        return Q(n, !0, "start");
      }), c = m(function (t) {
        if (a) {
          if (t >= $) return h(1, 0), Q(n, !0, "end"), d(), a = !1;

          if (t >= p) {
            var _e4 = s((t - p) / i);

            h(_e4, 1 - _e4);
          }
        }

        return a;
      });
    }

    var g = !1;
    return {
      start: function start() {
        g || (g = !0, N(n), s(l) ? (l = l(), (K || (K = Promise.resolve(), K.then(function () {
          K = null;
        })), K).then(h)) : h());
      },
      invalidate: function invalidate() {
        g = !1;
      },
      end: function end() {
        a && (d(), a = !1);
      }
    };
  }

  var et = "undefined" != typeof window ? window : "undefined" != typeof globalThis ? globalThis : global;

  function nt(t, e, n, i) {
    var _t$$$ = t.$$,
        c = _t$$$.fragment,
        l = _t$$$.on_mount,
        a = _t$$$.on_destroy,
        u = _t$$$.after_update;
    c && c.m(e, n), i || H(function () {
      var e = l.map(o).filter(s);
      a ? a.push.apply(a, _toConsumableArray(e)) : r(e), t.$$.on_mount = [];
    }), u.forEach(H);
  }

  function ot(t, e) {
    var n = t.$$;
    null !== n.fragment && (r(n.on_destroy), n.fragment && n.fragment.d(e), n.on_destroy = n.fragment = null, n.ctx = []);
  }

  function it(t, e) {
    -1 === t.$$.dirty[0] && (M.push(t), V || (V = !0, U.then(G)), t.$$.dirty.fill(0)), t.$$.dirty[e / 31 | 0] |= 1 << e % 31;
  }

  function rt(e, n, o, s, c, l, a) {
    var u = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [-1];
    var d = I;
    A(e);
    var f = e.$$ = {
      fragment: null,
      ctx: null,
      props: l,
      update: t,
      not_equal: c,
      bound: i(),
      on_mount: [],
      on_destroy: [],
      on_disconnect: [],
      before_update: [],
      after_update: [],
      context: new Map(n.context || (d ? d.$$.context : [])),
      callbacks: i(),
      dirty: u,
      skip_bound: !1,
      root: n.target || d.$$.root
    };
    a && a(f.root);
    var h = !1;

    if (f.ctx = o ? o(e, n.props || {}, function (t, n) {
      var i = (arguments.length <= 2 ? 0 : arguments.length - 2) ? arguments.length <= 2 ? undefined : arguments[2] : n;
      return f.ctx && c(f.ctx[t], f.ctx[t] = i) && (!f.skip_bound && f.bound[t] && f.bound[t](i), h && it(e, t)), n;
    }) : [], f.update(), h = !0, r(f.before_update), f.fragment = !!s && s(f.ctx), n.target) {
      if (n.hydrate) {
        var _t5 = function (t) {
          return Array.from(t.childNodes);
        }(n.target);

        f.fragment && f.fragment.l(_t5), _t5.forEach(v);
      } else f.fragment && f.fragment.c();

      n.intro && Y(e.$$.fragment), nt(e, n.target, n.anchor, n.customElement), G();
    }

    A(d);
  }

  var st;
  "function" == typeof HTMLElement && (st = /*#__PURE__*/function (_HTMLElement) {
    _inherits(st, _HTMLElement);

    function st() {
      var _this;

      _classCallCheck(this, st);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(st).call(this)), _this.attachShadow({
        mode: "open"
      });
      return _this;
    }

    _createClass(st, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var t = this.$$.on_mount;
        this.$$.on_disconnect = t.map(o).filter(s);

        for (var _t6 in this.$$.slotted) {
          this.appendChild(this.$$.slotted[_t6]);
        }
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(t, e, n) {
        this[t] = n;
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        r(this.$$.on_disconnect);
      }
    }, {
      key: "$destroy",
      value: function $destroy() {
        ot(this, 1), this.$destroy = t;
      }
    }, {
      key: "$on",
      value: function $on(t, e) {
        var n = this.$$.callbacks[t] || (this.$$.callbacks[t] = []);
        return n.push(e), function () {
          var t = n.indexOf(e);
          -1 !== t && n.splice(t, 1);
        };
      }
    }, {
      key: "$set",
      value: function $set(t) {
        this.$$set && !a(t) && (this.$$.skip_bound = !0, this.$$set(t), this.$$.skip_bound = !1);
      }
    }]);

    return st;
  }(_wrapNativeSuper(HTMLElement)));
  var ct, lt, at, ut, dt, ft, ht;

  function gt(t) {
    return function (e, n) {
      if (!e.hasOwnProperty("ownerDocument")) {
        Object.defineProperty(e, "ownerDocument", {
          get: function get() {
            return e.parentElement;
          }
        });
        var _t7 = e;

        for (; _t7.parentElement;) {
          _t7 = _t7.parentElement;
        }

        e.parentElement.head = _t7;
      }

      return t(e, n);
    };
  }

  function pt(t) {
    return t < .5 ? 4 * t * t * t : .5 * Math.pow(2 * t - 2, 3) + 1;
  }

  function mt(t) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$delay = _ref2.delay,
        e = _ref2$delay === void 0 ? 0 : _ref2$delay,
        n = _ref2.speed,
        o = _ref2.duration,
        _ref2$easing = _ref2.easing,
        i = _ref2$easing === void 0 ? pt : _ref2$easing;

    var r = t.getTotalLength();
    var s = getComputedStyle(t);
    return "butt" !== s.strokeLinecap && (r += parseInt(s.strokeWidth)), void 0 === o ? o = void 0 === n ? 800 : r / n : "function" == typeof o && (o = o(r)), {
      delay: e,
      duration: o,
      easing: i,
      css: function css(t, e) {
        return "stroke-dasharray: ".concat(t * r, " ").concat(e * r);
      }
    };
  }

  !function (t) {
    t[t.Failed = 0] = "Failed", t[t.NoBrowserSupport = 1] = "NoBrowserSupport", t[t.NoAudioConsent = 2] = "NoAudioConsent", t[t.__UnrecoverableErrors = 3] = "__UnrecoverableErrors", t[t.Disconnected = 4] = "Disconnected", t[t.Disconnecting = 5] = "Disconnecting", t[t.Connecting = 6] = "Connecting", t[t.Preinitialized = 7] = "Preinitialized", t[t.Initializing = 8] = "Initializing", t[t.Connected = 9] = "Connected", t[t.Stopping = 10] = "Stopping", t[t.Starting = 11] = "Starting", t[t.Recording = 12] = "Recording";
  }(ct || (ct = {})), function (t) {
    t.SpeechlyFirstConnect = "SpeechlyFirstConnect";
  }(lt || (lt = {})), function (t) {
    t.speechlypoweron = "speechlypoweron", t.holdstart = "holdstart", t.holdend = "holdend", t.speechstate = "speechstate", t.speechsegment = "speechsegment", t.speechhandled = "speechhandled", t.showhint = "showhint", t.transcriptdrawerhint = "hint", t.speechlyintroready = "speechlyintroready", t.speechlyintroclosed = "speechlyintroclosed";
  }(at || (at = {})), function (t) {
    t.Mic = "mic", t.MicActive = "micactive", t.Error = "error", t.Denied = "denied";
  }(ut || (ut = {})), function (t) {
    t.Hold = "hold", t.Click = "click", t.Noninteractive = "noninteractive";
  }(dt || (dt = {})), function (t) {
    t.None = "none", t.Connecting = "connecting", t.Busy = "busy";
  }(ft || (ft = {})), function (t) {
    t.None = "none", t.Whirl = "whirl";
  }(ht || (ht = {})), ct.Disconnected, ct.Disconnecting, ct.Connecting, ct.Preinitialized, ct.Initializing, ct.Connected, ct.Starting, ct.Recording, ct.Stopping, ct.Failed, ct.NoBrowserSupport, ct.NoAudioConsent;
  var $t = [0, 1];

  function yt(t, e, n, o) {
    if (e < n) return t[0];
    if (e > o) return t[t.length - 1];
    var i = (o - n) / (t.length - 1);
    if (i <= 0) return t[0];
    var r = (e - n) / i,
        s = Math.floor(r),
        c = Math.ceil(r),
        l = r - s;
    return (1 - l) * t[s] + l * t[c];
  }

  function bt(t) {
    !function (t, e, n) {
      var o = y(t);

      if (!o.getElementById(e)) {
        var _t8 = x("style");

        _t8.id = e, _t8.textContent = n, b(o, _t8);
      }
    }(t, "svelte-1fz8oog", "canvas.svelte-1fz8oog{display:block;width:1.35rem;height:1.5rem;margin:0;padding:0 0.8rem 0 0rem;flex-grow:0;flex-shrink:0;flex-basis:1.35rem}");
  }

  function wt(e) {
    var n;
    return {
      c: function c() {
        n = x("canvas"), P(n, "color", e[0]), P(n, "display", "block"), P(n, "width", "1.35rem"), P(n, "height", "1.5rem"), P(n, "margin", "0"), P(n, "padding", "0 0.8rem 0 0rem"), P(n, "flex-grow", "0"), P(n, "flex-shrink", "0"), P(n, "flex-basis", "1.35rem"), C(n, "class", "svelte-1fz8oog");
      },
      m: function m(t, o) {
        w(t, n, o), e[3](n);
      },
      p: function p(t, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
            e = _ref4[0];

        1 & e && P(n, "color", t[0]);
      },
      i: t,
      o: t,
      d: function d(t) {
        t && v(n), e[3](null);
      }
    };
  }

  function vt(t, e, n) {
    var _e$color = e.color,
        o = _e$color === void 0 ? "#60e0ff" : _e$color;

    var i = function i(t, e) {
      s = Date.now() > c ? t : Math.max(s, t), c = Date.now() + e;
    };

    var r,
        s = 0,
        c = 0,
        l = [0, 0];

    var a = function a(t, e, n, o, i, r) {
      o < 2 * r && (r = o / 2), i < 2 * r && (r = i / 2), t.beginPath(), t.moveTo(e + r, n), t.arcTo(e + o, n, e + o, n + i, r), t.arcTo(e + o, n + i, e, n + i, r), t.arcTo(e, n + i, e, n, r), t.arcTo(e, n, e + o, n, r), t.closePath();
    };

    var u;
    return u = function u() {
      var t;

      var e = 2 * (l.length - 1) + 1,
          o = 3 * e + 1 * (e - 1),
          u = function u() {
        if (t = requestAnimationFrame(u), !r) return;
        var e = r.getContext("2d");
        if (!e) return;

        var i = function (t) {
          var e = t.backingStorePixelRatio || t.webkitBackingStorePixelRatio || t.mozBackingStorePixelRatio || t.msBackingStorePixelRatio || t.oBackingStorePixelRatio || t.backingStorePixelRatio || 1;
          return (window.devicePixelRatio || 1) / e;
        }(e),
            d = Number.parseInt(getComputedStyle(r).getPropertyValue("width").slice(0, -2)),
            f = Number.parseInt(getComputedStyle(r).getPropertyValue("height").slice(0, -2));

        n(1, r.width = d * i, r), n(1, r.height = f * i, r), Date.now() < c ? l[0] = .15 * s + .85 * l[0] : l[0] = .0625 + .75 * l[0];
        var h = 1;

        for (; h < l.length;) {
          l[h] = .25 * l[h - 1] + .5 * l[h] + .0625, h++;
        }

        e.clearRect(0, 0, r.width, r.height);
        var g = 3 / o * r.width * .5,
            p = 4 / o * r.width;

        for (e.fillStyle = r.style.color || "#000000", h = 0; h < l.length; h++) {
          var _t9 = l[h] * r.height;

          _t9 * r.height > 2 * g ? a(e, .5 * r.width - g + h * p, .5 * (r.height - _t9), 2 * g, _t9, g) : (e.beginPath(), e.arc(.5 * r.width + h * p, .5 * r.height, _t9 * r.height * .5, 0, 2 * Math.PI)), e.fill(), h > 0 && (_t9 * r.height > 2 * g ? a(e, .5 * r.width - g - h * p, .5 * (r.height - _t9), 2 * g, _t9, g) : (e.beginPath(), e.arc(.5 * r.width - h * p, .5 * r.height, _t9 * r.height * .5, 0, 2 * Math.PI)), e.fill());
        }
      };

      return u(), i(1, 500), function () {
        cancelAnimationFrame(t);
      };
    }, B().$$.on_mount.push(u), t.$$set = function (t) {
      "color" in t && n(0, o = t.color);
    }, [o, r, i, function (t) {
      j[t ? "unshift" : "push"](function () {
        r = t, n(1, r);
      });
    }];
  }

  var xt = /*#__PURE__*/function (_ref5) {
    _inherits(xt, _ref5);

    function xt(t) {
      var _this2;

      _classCallCheck(this, xt);

      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(xt).call(this)), rt(_assertThisInitialized(_assertThisInitialized(_this2)), t, vt, wt, c, {
        color: 0,
        updateVU: 2
      }, bt);
      return _this2;
    }

    _createClass(xt, [{
      key: "updateVU",
      get: function get() {
        return this.$$.ctx[2];
      }
    }]);

    return xt;
  }( /*#__PURE__*/function () {
    function _class() {
      _classCallCheck(this, _class);
    }

    _createClass(_class, [{
      key: "$destroy",
      value: function $destroy() {
        ot(this, 1), this.$destroy = t;
      }
    }, {
      key: "$on",
      value: function $on(t, e) {
        var n = this.$$.callbacks[t] || (this.$$.callbacks[t] = []);
        return n.push(e), function () {
          var t = n.indexOf(e);
          -1 !== t && n.splice(t, 1);
        };
      }
    }, {
      key: "$set",
      value: function $set(t) {
        this.$$set && !a(t) && (this.$$.skip_bound = !0, this.$$set(t), this.$$.skip_bound = !1);
      }
    }]);

    return _class;
  }());

  var kt = [];

  function _t(t) {
    return "[object Date]" === Object.prototype.toString.call(t);
  }

  function Et(t, e) {
    if (t === e || t != t) return function () {
      return t;
    };
    var n = typeof t;
    if (n !== typeof e || Array.isArray(t) !== Array.isArray(e)) throw new Error("Cannot interpolate values of different type");

    if (Array.isArray(t)) {
      var _n3 = e.map(function (e, n) {
        return Et(t[n], e);
      });

      return function (t) {
        return _n3.map(function (e) {
          return e(t);
        });
      };
    }

    if ("object" === n) {
      if (!t || !e) throw new Error("Object cannot be null");

      if (_t(t) && _t(e)) {
        t = t.getTime();

        var _n5 = (e = e.getTime()) - t;

        return function (e) {
          return new Date(t + e * _n5);
        };
      }

      var _n4 = Object.keys(e),
          _o2 = {};

      return _n4.forEach(function (n) {
        _o2[n] = Et(t[n], e[n]);
      }), function (t) {
        var e = {};
        return _n4.forEach(function (n) {
          e[n] = _o2[n](t);
        }), e;
      };
    }

    if ("number" === n) {
      var _n6 = e - t;

      return function (e) {
        return t + e * _n6;
      };
    }

    throw new Error("Cannot interpolate ".concat(n, " values"));
  }

  function Tt(o) {
    var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var r = function (e) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t;
      var o;
      var i = new Set();

      function r(t) {
        if (c(e, t) && (e = t, o)) {
          var _t10 = !kt.length;

          var _iterator2 = _createForOfIteratorHelper(i),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _t12 = _step2.value;
              _t12[1](), kt.push(_t12, e);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          if (_t10) {
            for (var _t11 = 0; _t11 < kt.length; _t11 += 2) {
              kt[_t11][0](kt[_t11 + 1]);
            }

            kt.length = 0;
          }
        }
      }

      return {
        set: r,
        update: function update(t) {
          r(t(e));
        },
        subscribe: function subscribe(s) {
          var c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t;
          var l = [s, c];
          return i.add(l), 1 === i.size && (o = n(r) || t), s(e), function () {
            i.delete(l), 0 === i.size && (o(), o = null);
          };
        }
      };
    }(o);

    var s,
        l = o;

    function a(t, c) {
      if (null == o) return r.set(o = t), Promise.resolve();
      l = t;

      var a = s,
          u = !1,
          _n7 = n(n({}, i), c),
          _n7$delay = _n7.delay,
          d = _n7$delay === void 0 ? 0 : _n7$delay,
          _n7$duration = _n7.duration,
          h = _n7$duration === void 0 ? 400 : _n7$duration,
          _n7$easing = _n7.easing,
          g = _n7$easing === void 0 ? e : _n7$easing,
          _n7$interpolate = _n7.interpolate,
          p = _n7$interpolate === void 0 ? Et : _n7$interpolate;

      if (0 === h) return a && (a.abort(), a = null), r.set(o = l), Promise.resolve();
      var $ = f() + d;
      var y;
      return s = m(function (e) {
        if (e < $) return !0;
        u || (y = p(o, t), "function" == typeof h && (h = h(o, t)), u = !0), a && (a.abort(), a = null);
        var n = e - $;
        return n > h ? (r.set(o = t), !1) : (r.set(o = y(g(n / h))), !0);
      }), s.promise;
    }

    return {
      set: a,
      update: function update(t, e) {
        return a(t(l, o), e);
      },
      subscribe: r.subscribe
    };
  }

  var Ct = et.window;

  function Pt(t, e, n) {
    var o = t.slice();
    return o[42] = e[n], o[44] = n, o;
  }

  function zt(t) {
    var e;
    return {
      c: function c() {
        e = x("div"), C(e, "class", "TransscriptItemBgDiv");
      },
      m: function m(t, n) {
        w(t, e, n);
      },
      d: function d(t) {
        t && v(e);
      }
    };
  }

  function St(e) {
    var n, o;
    return {
      c: function c() {
        n = x("div"), n.textContent = "Listening...", C(n, "class", "listening");
      },
      m: function m(t, e) {
        w(t, n, e);
      },
      i: function i(t) {
        o || H(function () {
          o = tt(n, e[21], {
            duration: 400
          }), o.start();
        });
      },
      o: t,
      d: function d(t) {
        t && v(n);
      }
    };
  }

  function Dt(e) {
    var n, o;
    return {
      c: function c() {
        n = x("div"), C(n, "class", "TransscriptItemBgDiv");
      },
      m: function m(t, e) {
        w(t, n, e);
      },
      p: function p(t, n) {
        e = t;
      },
      i: function i(t) {
        o || H(function () {
          o = tt(n, e[21], {
            duration: e[14]
          }), o.start();
        });
      },
      o: t,
      d: function d(t) {
        t && v(n);
      }
    };
  }

  function It(t) {
    var e, n;
    return {
      c: function c() {
        e = x("span"), C(e, "style", n = t[44] < t[11].length - 1 ? "width:0.25em;" : t[13] ? "width:1.2em;" : "");
      },
      m: function m(t, n) {
        w(t, e, n);
      },
      p: function p(t, o) {
        10240 & o[0] && n !== (n = t[44] < t[11].length - 1 ? "width:0.25em;" : t[13] ? "width:1.2em;" : "") && C(e, "style", n);
      },
      d: function d(t) {
        t && v(e);
      }
    };
  }

  function Rt(e) {
    var n,
        o,
        _i,
        r,
        s,
        c,
        l,
        a = e[42].word + "",
        u = e[16] && Dt(e),
        _d = e[44] < e[11].length && It(e);

    return {
      c: function c() {
        n = x("div"), u && u.c(), o = E(), _i = x("div"), r = _(a), s = E(), _d && _d.c(), C(_i, "class", "TransscriptItemContent"), C(n, "class", l = "TranscriptItem " + e[23](e[42])), z(n, "Entity", null !== e[42].entityType), z(n, "Final", e[42].isFinal);
      },
      m: function m(t, e) {
        w(t, n, e), u && u.m(n, null), $(n, o), $(n, _i), $(_i, r), $(_i, s), _d && _d.m(_i, null);
      },
      p: function p(t, s) {
        (e = t)[16] ? u ? 65536 & s[0] && Y(u, 1) : (u = Dt(e), u.c(), Y(u, 1), u.m(n, o)) : u && (u.d(1), u = null), 2048 & s[0] && a !== (a = e[42].word + "") && function (t, e) {
          e = "" + e, t.wholeText !== e && (t.data = e);
        }(r, a), e[44] < e[11].length ? _d ? _d.p(e, s) : (_d = It(e), _d.c(), _d.m(_i, null)) : _d && (_d.d(1), _d = null), 2048 & s[0] && l !== (l = "TranscriptItem " + e[23](e[42])) && C(n, "class", l), 2048 & s[0] && z(n, "Entity", null !== e[42].entityType), 2048 & s[0] && z(n, "Final", e[42].isFinal);
      },
      i: function i(t) {
        Y(u), c || H(function () {
          c = tt(_i, e[21], {
            duration: e[14]
          }), c.start();
        });
      },
      o: t,
      d: function d(t) {
        t && v(n), u && u.d(), _d && _d.d();
      }
    };
  }

  function Ft(e) {
    var n, o, i, r, s, _c, l, a;

    return {
      c: function c() {
        n = x("div"), o = x("div"), i = E(), r = x("div"), s = k("svg"), _c = k("path"), C(o, "class", "TransscriptItemBgDiv"), P(o, "background-color", e[5]), C(_c, "stroke", "currentColor"), C(_c, "stroke-width", "3"), C(_c, "d", "M7.191 11.444l4.059 6.107 7.376-12.949"), C(_c, "fill", "none"), C(_c, "fill-rule", "evenodd"), P(s, "width", "2rem"), P(s, "height", "2rem"), P(s, "position", "absolute"), P(s, "transform", "translate(-0.6rem, -0.5rem)"), P(s, "stroke", "#eee"), C(s, "viewBox", "0 0 24 24"), C(s, "xmlns", "http://www.w3.org/2000/svg"), P(r, "width", "1.0rem"), P(r, "height", "1rem"), P(r, "position", "relative"), C(n, "class", "TranscriptItem");
      },
      m: function m(t, e) {
        w(t, n, e), $(n, o), $(n, i), $(n, r), $(r, s), $(s, _c);
      },
      p: function p(t, e) {
        32 & e[0] && P(o, "background-color", t[5]);
      },
      i: function i(t) {
        l || H(function () {
          l = tt(_c, e[20], {
            duration: 500
          }), l.start();
        }), a || H(function () {
          a = tt(n, e[21], {
            duration: 200,
            maxWidth: 3
          }), a.start();
        });
      },
      o: t,
      d: function d(t) {
        t && v(n);
      }
    };
  }

  function Nt(t) {
    var e;
    return {
      c: function c() {
        e = x("link"), C(e, "href", "https://fonts.googleapis.com/css2?family=Saira+Condensed:wght@700&display=swap"), C(e, "rel", "stylesheet");
      },
      m: function m(t, n) {
        w(t, e, n);
      },
      d: function d(t) {
        t && v(e);
      }
    };
  }

  function At(t) {
    var e;
    return {
      c: function c() {
        e = x("link"), C(e, "href", t[10]), C(e, "rel", "stylesheet");
      },
      m: function m(t, n) {
        w(t, e, n);
      },
      p: function p(t, n) {
        1024 & n[0] && C(e, "href", t[10]);
      },
      d: function d(t) {
        t && v(e);
      }
    };
  }

  function Bt(e) {
    var n,
        o,
        i,
        r,
        s,
        _c2,
        l,
        a,
        u,
        _d2,
        f,
        h,
        g,
        p,
        _m,
        y = e[16] && zt(),
        b = {
      color: e[5]
    };

    s = new xt({
      props: b
    }), e[34](s);
    var k = e[17] && St(e),
        _ = e[11],
        S = [];

    for (var _t13 = 0; _t13 < _.length; _t13 += 1) {
      S[_t13] = Rt(Pt(e, _, _t13));
    }

    var D = e[13] && Ft(e),
        I = e[15] && Nt(),
        R = void 0 !== e[10] && At(e);
    return {
      c: function c() {
        var g;
        n = x("main"), o = x("div"), y && y.c(), i = E(), r = x("div"), (g = s.$$.fragment) && g.c(), _c2 = E(), k && k.c(), l = E();

        for (var _t14 = 0; _t14 < S.length; _t14 += 1) {
          S[_t14].c();
        }

        a = E(), D && D.c(), u = E(), I && I.c(), _d2 = T(), f = E(), R && R.c(), h = T(), this.c = t, C(r, "class", "TransscriptItemContent"), C(o, "class", "TranscriptItem"), C(n, "class", "BigTranscript"), P(n, "--voffset", e[1]), P(n, "--hoffset", e[2]), P(n, "--fontsize", e[3]), P(n, "--color", e[4]), P(n, "--highlight-color", e[5]), P(n, "--text-bg-color", e[6]), P(n, "--gradient-stop1", e[7]), P(n, "--gradient-stop2", e[8]), P(n, "--marginbottom", e[9]), P(n, "--transition", e[18].transition), P(n, "opacity", e[18].transition), P(n, "max-height", 10 * yt($t, e[18].transition, 0, .6) + "rem"), P(n, "visibility", 0 !== e[18].transition ? "visible" : "hidden"), z(n, "placementTop", "top" === e[0]), z(n, "defaultTypography", e[15]);
      },
      m: function m(t, b) {
        w(t, n, b), $(n, o), y && y.m(o, null), $(o, i), $(o, r), nt(s, r, null), $(r, _c2), k && k.m(r, null), $(n, l);

        for (var _t15 = 0; _t15 < S.length; _t15 += 1) {
          S[_t15].m(n, null);
        }

        var v, x, _, E;

        $(n, a), D && D.m(n, null), w(t, u, b), I && I.m(document.head, null), $(document.head, _d2), w(t, f, b), R && R.m(t, b), w(t, h, b), g = !0, p || (v = Ct, x = "message", _ = e[22], v.addEventListener(x, _, E), _m = function _m() {
          return v.removeEventListener(x, _, E);
        }, p = !0);
      },
      p: function p(t, e) {
        t[16] ? y || (y = zt(), y.c(), y.m(o, i)) : y && (y.d(1), y = null);
        var c = {};

        if (32 & e[0] && (c.color = t[5]), s.$set(c), t[17] ? k ? 131072 & e[0] && Y(k, 1) : (k = St(t), k.c(), Y(k, 1), k.m(r, null)) : k && (k.d(1), k = null), 8464384 & e[0]) {
          var _o3;

          for (_ = t[11], _o3 = 0; _o3 < _.length; _o3 += 1) {
            var _i2 = Pt(t, _, _o3);

            S[_o3] ? (S[_o3].p(_i2, e), Y(S[_o3], 1)) : (S[_o3] = Rt(_i2), S[_o3].c(), Y(S[_o3], 1), S[_o3].m(n, a));
          }

          for (; _o3 < S.length; _o3 += 1) {
            S[_o3].d(1);
          }

          S.length = _.length;
        }

        t[13] ? D ? (D.p(t, e), 8192 & e[0] && Y(D, 1)) : (D = Ft(t), D.c(), Y(D, 1), D.m(n, null)) : D && (D.d(1), D = null), (!g || 2 & e[0]) && P(n, "--voffset", t[1]), (!g || 4 & e[0]) && P(n, "--hoffset", t[2]), (!g || 8 & e[0]) && P(n, "--fontsize", t[3]), (!g || 16 & e[0]) && P(n, "--color", t[4]), (!g || 32 & e[0]) && P(n, "--highlight-color", t[5]), (!g || 64 & e[0]) && P(n, "--text-bg-color", t[6]), (!g || 128 & e[0]) && P(n, "--gradient-stop1", t[7]), (!g || 256 & e[0]) && P(n, "--gradient-stop2", t[8]), (!g || 512 & e[0]) && P(n, "--marginbottom", t[9]), (!g || 262144 & e[0]) && P(n, "--transition", t[18].transition), (!g || 262144 & e[0]) && P(n, "opacity", t[18].transition), (!g || 262144 & e[0]) && P(n, "max-height", 10 * yt($t, t[18].transition, 0, .6) + "rem"), (!g || 262144 & e[0]) && P(n, "visibility", 0 !== t[18].transition ? "visible" : "hidden"), 1 & e[0] && z(n, "placementTop", "top" === t[0]), 32768 & e[0] && z(n, "defaultTypography", t[15]), t[15] ? I || (I = Nt(), I.c(), I.m(_d2.parentNode, _d2)) : I && (I.d(1), I = null), void 0 !== t[10] ? R ? R.p(t, e) : (R = At(t), R.c(), R.m(h.parentNode, h)) : R && (R.d(1), R = null);
      },
      i: function i(t) {
        if (!g) {
          Y(s.$$.fragment, t), Y(k);

          for (var _t16 = 0; _t16 < _.length; _t16 += 1) {
            Y(S[_t16]);
          }

          Y(D), g = !0;
        }
      },
      o: function o(t) {
        !function (t, e, n, o) {
          if (t && t.o) {
            if (X.has(t)) return;
            X.add(t), (void 0).c.push(function () {
              X.delete(t), o && (n && t.d(1), o());
            }), t.o(e);
          }
        }(s.$$.fragment, t), g = !1;
      },
      d: function d(t) {
        t && v(n), y && y.d(), e[34](null), ot(s), k && k.d(), function (t, e) {
          for (var _n8 = 0; _n8 < t.length; _n8 += 1) {
            t[_n8] && t[_n8].d(e);
          }
        }(S, t), D && D.d(), t && v(u), I && I.d(t), v(_d2), t && v(f), R && R.d(t), t && v(h), p = !1, _m();
      }
    };
  }

  function Mt(t, e, n) {
    var o,
        i,
        r,
        s,
        c,
        l,
        a,
        d,
        f = e.placement,
        _e$voffset = e.voffset,
        h = _e$voffset === void 0 ? "3rem" : _e$voffset,
        _e$hoffset = e.hoffset,
        g = _e$hoffset === void 0 ? "2rem" : _e$hoffset,
        _e$fontsize = e.fontsize,
        p = _e$fontsize === void 0 ? "1.5rem" : _e$fontsize,
        _e$color2 = e.color,
        m = _e$color2 === void 0 ? "#ffffff" : _e$color2,
        _e$highlightcolor = e.highlightcolor,
        $ = _e$highlightcolor === void 0 ? "#15e8b5" : _e$highlightcolor,
        _e$backgroundcolor = e.backgroundcolor,
        y = _e$backgroundcolor === void 0 ? "#202020" : _e$backgroundcolor,
        _e$gradientstop = e.gradientstop1,
        b = _e$gradientstop === void 0 ? "#ffffff88" : _e$gradientstop,
        _e$gradientstop2 = e.gradientstop2,
        w = _e$gradientstop2 === void 0 ? "#ffffffcc" : _e$gradientstop2,
        _e$marginbottom = e.marginbottom,
        v = _e$marginbottom === void 0 ? "0rem" : _e$marginbottom,
        x = e.formattext,
        k = e.demomode,
        _ = e.customcssurl,
        E = e.customtypography,
        T = [],
        C = null,
        P = null,
        z = ct.Disconnected,
        S = !1,
        D = !1,
        I = !1,
        R = Tt({
      transition: 0
    }, {
      duration: 200
    });
    u(t, R, function (t) {
      return n(18, a = t);
    });

    var F = B(),
        N = gt(mt),
        A = gt(function (t, _ref6) {
      var _ref6$delay = _ref6.delay,
          e = _ref6$delay === void 0 ? 0 : _ref6$delay,
          _ref6$duration = _ref6.duration,
          n = _ref6$duration === void 0 ? 350 : _ref6$duration,
          _ref6$maxWidth = _ref6.maxWidth,
          o = _ref6$maxWidth === void 0 ? 10 : _ref6$maxWidth;
      return {
        delay: e,
        duration: n,
        css: function css(t) {
          return "\n        max-width: ".concat(yt($t, t, 0, 1) * o, "rem;\n      ");
        }
      };
    }),
        M = function M(t) {
      n(13, I = I || t);
    },
        O = function O(t) {
      n(30, z = t), z === ct.Recording && (n(13, I = !1), n(11, T = []), P = null);
    },
        L = function L(t) {
      if (void 0 === t) return;
      d && (s || z === ct.Recording) && d.updateVU(.5 * Math.random() + .5, 75 * Math.random() + 75), t.isFinal ? U(T.length > 0 ? s ? 3500 : 2e3 : 0) : T.length > 0 && (S || n(31, S = !0), U(2e3));
      var e = "".concat(t.contextId, "/").concat(t.id);
      null !== P ? P !== e && (n(13, I = !1), P = e) : P = e, n(11, T = []), t.words.forEach(function (t) {
        n(11, T[t.index] = {
          word: t.value,
          serialNumber: t.index,
          entityType: null,
          isFinal: t.isFinal,
          hide: !1
        }, T);
      }), r ? t.entities.forEach(function (t) {
        n(11, T[t.startPosition].word = t.value, T), n(11, T[t.startPosition].entityType = t.type, T), n(11, T[t.startPosition].isFinal = t.isFinal, T), n(11, T[t.startPosition].hide = !1, T);

        for (var _e5 = t.startPosition + 1; _e5 < t.endPosition; _e5++) {
          T[_e5] && n(11, T[_e5].hide = !0, T);
        }
      }) : t.entities.forEach(function (t) {
        for (var _e6 = t.startPosition; _e6 < t.endPosition; _e6++) {
          T[_e6] && (n(11, T[_e6].entityType = t.type, T), n(11, T[_e6].isFinal = t.isFinal, T));
        }
      }), n(11, T = T.filter(function (t) {
        return !t.hide;
      }));
    },
        U = function U() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      V(), C = window.setTimeout(function () {
        C = null, S && n(31, S = !1);
      }, t);
    },
        V = function V() {
      null !== C && (window.clearTimeout(C), C = null);
    };

    return t.$$set = function (t) {
      "placement" in t && n(0, f = t.placement), "voffset" in t && n(1, h = t.voffset), "hoffset" in t && n(2, g = t.hoffset), "fontsize" in t && n(3, p = t.fontsize), "color" in t && n(4, m = t.color), "highlightcolor" in t && n(5, $ = t.highlightcolor), "backgroundcolor" in t && n(6, y = t.backgroundcolor), "gradientstop1" in t && n(7, b = t.gradientstop1), "gradientstop2" in t && n(8, w = t.gradientstop2), "marginbottom" in t && n(9, v = t.marginbottom), "formattext" in t && n(24, x = t.formattext), "demomode" in t && n(25, k = t.demomode), "customcssurl" in t && n(10, _ = t.customcssurl), "customtypography" in t && n(26, E = t.customtypography);
    }, t.$$.update = function () {
      if (2048 & t.$$.dirty[0] && n(17, o = 0 === T.length), 64 & t.$$.dirty[0] && n(16, i = "none" !== y), 16777216 & t.$$.dirty[0] && (r = void 0 === x || "false" !== x), 33554432 & t.$$.dirty[0] && n(33, s = void 0 !== k && "false" !== k), 67108864 & t.$$.dirty[0] && n(15, c = void 0 === E || "false" === E), 4 & t.$$.dirty[1] && n(14, l = s ? 800 : 350), 1073741824 & t.$$.dirty[0] | 3 & t.$$.dirty[1]) {
        var _t17 = z === ct.Recording || S;

        _t17 !== D && (e = "visibilitychanged", a = _t17, F.dispatchEvent(new CustomEvent(e, {
          detail: a,
          composed: !0
        }))), n(32, D = _t17), R.set({
          transition: D ? 1 : 0
        });
      }

      var e, a;
      4 & t.$$.dirty[1] && (s || U(0));
    }, [f, h, g, p, m, $, y, b, w, v, _, T, d, I, l, c, i, o, a, R, N, A, function (t) {
      switch (t.data.type) {
        case at.speechsegment:
          L(t.data.segment);
          break;

        case at.speechhandled:
          M(t.data.success);
          break;

        case at.speechstate:
          O(t.data.state);
      }
    }, function (t) {
      return t.entityType || "";
    }, x, k, E, M, O, L, z, S, D, s, function (t) {
      j[t ? "unshift" : "push"](function () {
        d = t, n(12, d);
      });
    }];
  }

  var jt = /*#__PURE__*/function (_st) {
    _inherits(jt, _st);

    function jt(t) {
      var _this3;

      _classCallCheck(this, jt);

      _this3 = _possibleConstructorReturn(this, _getPrototypeOf(jt).call(this)), _this3.shadowRoot.innerHTML = "<style>main{position:relative;user-select:none;display:flex;flex-direction:row;justify-content:start;flex-wrap:wrap;margin-bottom:calc(var(--marginbottom) * var(--transition));height:fit-content}.defaultTypography{font-family:'Saira Condensed', sans-serif;text-transform:uppercase;color:var(--color);font-size:var(--fontsize);line-height:135%}.TranscriptItem{position:relative;display:flex;flex-direction:row;align-items:center}.Entity{color:var(--highlight-color)}.TransscriptItemContent{z-index:1;display:flex;flex-wrap:nowrap;flex-direction:row;align-items:center;overflow:hidden;white-space:nowrap}.TransscriptItemBgDiv{position:absolute;box-sizing:content-box;width:100%;height:100%;top:-0.2rem;left:-0.8rem;margin:0;padding:0.2rem 0.8rem;background-color:var(--text-bg-color);z-index:-1}.placementTop{position:fixed;top:0;left:0;right:0;bottom:0;margin:var(--voffset) var(--hoffset) 0 var(--hoffset);z-index:50;pointer-events:none}.listening{animation:flow 1s linear infinite;background:linear-gradient(-60deg, var(--gradient-stop1), var(--gradient-stop2), var(--gradient-stop1), var(--gradient-stop2), var(--gradient-stop1));background-size:200%;-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;-webkit-box-decoration-break:clone}@keyframes flow{0%{background-position:100% 50%}100%{background-position:0% 50%}}</style>", rt(_assertThisInitialized(_assertThisInitialized(_this3)), {
        target: _this3.shadowRoot,
        props: S(_this3.attributes),
        customElement: !0
      }, Mt, Bt, l, {
        placement: 0,
        voffset: 1,
        hoffset: 2,
        fontsize: 3,
        color: 4,
        highlightcolor: 5,
        backgroundcolor: 6,
        gradientstop1: 7,
        gradientstop2: 8,
        marginbottom: 9,
        formattext: 24,
        demomode: 25,
        customcssurl: 10,
        customtypography: 26,
        speechhandled: 27,
        speechstate: 28,
        speechsegment: 29
      }, null, [-1, -1]), t && (t.target && w(t.target, _assertThisInitialized(_assertThisInitialized(_this3)), t.anchor), t.props && (_this3.$set(t.props), G()));
      return _this3;
    }

    _createClass(jt, [{
      key: "placement",
      get: function get() {
        return this.$$.ctx[0];
      },
      set: function set(t) {
        this.$$set({
          placement: t
        }), G();
      }
    }, {
      key: "voffset",
      get: function get() {
        return this.$$.ctx[1];
      },
      set: function set(t) {
        this.$$set({
          voffset: t
        }), G();
      }
    }, {
      key: "hoffset",
      get: function get() {
        return this.$$.ctx[2];
      },
      set: function set(t) {
        this.$$set({
          hoffset: t
        }), G();
      }
    }, {
      key: "fontsize",
      get: function get() {
        return this.$$.ctx[3];
      },
      set: function set(t) {
        this.$$set({
          fontsize: t
        }), G();
      }
    }, {
      key: "color",
      get: function get() {
        return this.$$.ctx[4];
      },
      set: function set(t) {
        this.$$set({
          color: t
        }), G();
      }
    }, {
      key: "highlightcolor",
      get: function get() {
        return this.$$.ctx[5];
      },
      set: function set(t) {
        this.$$set({
          highlightcolor: t
        }), G();
      }
    }, {
      key: "backgroundcolor",
      get: function get() {
        return this.$$.ctx[6];
      },
      set: function set(t) {
        this.$$set({
          backgroundcolor: t
        }), G();
      }
    }, {
      key: "gradientstop1",
      get: function get() {
        return this.$$.ctx[7];
      },
      set: function set(t) {
        this.$$set({
          gradientstop1: t
        }), G();
      }
    }, {
      key: "gradientstop2",
      get: function get() {
        return this.$$.ctx[8];
      },
      set: function set(t) {
        this.$$set({
          gradientstop2: t
        }), G();
      }
    }, {
      key: "marginbottom",
      get: function get() {
        return this.$$.ctx[9];
      },
      set: function set(t) {
        this.$$set({
          marginbottom: t
        }), G();
      }
    }, {
      key: "formattext",
      get: function get() {
        return this.$$.ctx[24];
      },
      set: function set(t) {
        this.$$set({
          formattext: t
        }), G();
      }
    }, {
      key: "demomode",
      get: function get() {
        return this.$$.ctx[25];
      },
      set: function set(t) {
        this.$$set({
          demomode: t
        }), G();
      }
    }, {
      key: "customcssurl",
      get: function get() {
        return this.$$.ctx[10];
      },
      set: function set(t) {
        this.$$set({
          customcssurl: t
        }), G();
      }
    }, {
      key: "customtypography",
      get: function get() {
        return this.$$.ctx[26];
      },
      set: function set(t) {
        this.$$set({
          customtypography: t
        }), G();
      }
    }, {
      key: "speechhandled",
      get: function get() {
        return this.$$.ctx[27];
      }
    }, {
      key: "speechstate",
      get: function get() {
        return this.$$.ctx[28];
      }
    }, {
      key: "speechsegment",
      get: function get() {
        return this.$$.ctx[29];
      }
    }], [{
      key: "observedAttributes",
      get: function get() {
        return ["placement", "voffset", "hoffset", "fontsize", "color", "highlightcolor", "backgroundcolor", "gradientstop1", "gradientstop2", "marginbottom", "formattext", "demomode", "customcssurl", "customtypography", "speechhandled", "speechstate", "speechsegment"];
      }
    }]);

    return jt;
  }(st);

  customElements.get("big-transcript") ? console.warn("Skipping re-defining customElement big-transcript") : customElements.define("big-transcript", jt);
});